/* Клик по CTA — конверсионное действие, дольше ждать ответа смысла нет */
export const CTA_REQUEST_TIMEOUT_MS = 5000;

export interface IAbortableRequest<TResult> {
  unwrap(): Promise<TResult>;
  abort(): void;
}

/** Зависание сети — не ошибка, `catch` его не поймает, а кнопка на время запроса заблокирована. */
export function withRequestTimeout<TResult>(
  request: IAbortableRequest<TResult>,
  timeoutMs: number = CTA_REQUEST_TIMEOUT_MS,
): Promise<TResult> {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const timeout = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => {
      /* Без отмены RTK Query продолжит держать isFetching, и кнопка останется disabled */
      request.abort();
      reject(new Error('Таймаут запроса'));
    }, timeoutMs);
  });

  return Promise.race([request.unwrap(), timeout]).finally(() => clearTimeout(timer));
}
